import { render, staticRenderFns } from "./MenuMng.vue?vue&type=template&id=491d3d00"
import script from "./MenuMng.vue?vue&type=script&lang=js"
export * from "./MenuMng.vue?vue&type=script&lang=js"
import style0 from "./MenuMng.vue?vue&type=style&index=0&id=491d3d00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports